import { CapacitorHttp } from "@capacitor/core";
import { baseUrl, requestOptions } from "./api";
import { CapacitorHttpAuth, getCookies } from "./auth";
import { useQuery } from "react-query";
import {
  Damage,
  DamageApi,
  DamageType,
  VehicleDamage,
} from "../types/api/damage.types";

export const getDamageTypes = async ({
  page,
  itemsPerPage,
  vehiclePartId,
}: {
  page?: string;
  itemsPerPage?: string;
  vehiclePartId?: string | string[];
}) => {
  let response = await CapacitorHttpAuth({
    url: `${baseUrl}/driver/damageTypes`,
    method: "GET",
    params: {
      page: page || "1",
      itemsPerPage: itemsPerPage || "30",
      "vehiclePart.id": vehiclePartId || [],
    },
  });

  if (response) {
    return response.data;
  } else {
    return null;
  }
};

export const useGetDamageTypeQuery = ({
  page,
  itemsPerPage,
  vehiclePartId,
}: {
  page?: string;
  itemsPerPage?: string;
  vehiclePartId?: string | string[];
}) => {
  return useQuery({
    queryKey: ["getDamageType", vehiclePartId],
    queryFn: async () => {
      if (vehiclePartId === undefined) {
          return [];
      }
      let response = await CapacitorHttpAuth({
        url: `${baseUrl}/driver/damageTypes`,
        method: "GET",
        params: {
          page: page || "1",
          itemsPerPage: itemsPerPage || "30",
          "vehiclePart.id": vehiclePartId || [],
        },
      });
      return response.data as DamageType[];
    },
  });
};

export const useGetDamagesQuery = ({
  page,
  itemsPerPage,
  journeyDriverId,
  vehicleId,
  moment,
}: {
  page?: string;
  itemsPerPage?: string;
  journeyDriverId?: string | string[];
  vehicleId?: string | string[];
  moment?: string | string[];
}) => {
  return useQuery({
    queryKey: ["getDamages"],
    queryFn: async () => {
      let response = await CapacitorHttpAuth({
        url: `${baseUrl}/driver/damages`,
        method: "GET",
        params: {
          page: page || "1",
          itemsPerPage: itemsPerPage || "30",
          "vehicle.id": vehicleId || [],
          "journey.driver.id": journeyDriverId || [],
          moment: moment || [],
        },
      });
      return response.data as VehicleDamage[];
    },
  });
};

export const createDamage = async ({
  vehicleId,
  journeyId,
  damageTypeId,
  moment,
  picture,
  comment,
}: Damage) => {
  let response = await CapacitorHttpAuth({
    url: `${baseUrl}/driver/damage`,
    headers: {
      "content-type": "multipart/form-data",
    },
    method: "POST",
    data: {
      vehicleId,
      journeyId,
      damageTypeId,
      moment,
      picture,
      comment,
    },
  });
  if (response.data) {
    return response.data as DamageApi;
  }
  return;
};

export const getDamageTypeById = async (damageTypeId: string) => {
  let response = await CapacitorHttpAuth({
    url: `${baseUrl}/driver/damageTypes/${damageTypeId}`,
    method: "GET",
  });
  return response.data as VehicleDamage;
};
